/**************************************************
 * Nombre:       Lista_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import Tarjeta_Productos from "../../../Tarjetas/Tarjeta_Productos";

const Lista_Productos = ({items = []}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={sCell ? 2 : 6}
            sx={{px: sCell ? 3 : 0}}
        >

            {items.map((item) => (
                <Grid container size={{xs: 12, sm: 3, md: 2.4}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Productos item={item}/>
                </Grid>
            ))}


        </Grid>
    )

}
export default Lista_Productos

